module.exports = __webpack_public_path__ + "static/img/Slider_Icon1.5094ca44.svg";